import { FC } from 'react';
import styles from './interest-group.module.scss';
import CheckboxTag from 'react-components/inputs-comp/checkbox-tag/checkbox-tag';
import { InterestGroup as InterestGroupT } from 'graphql-types';
import SimpleCard from 'react-components/simple-card/simple-card';
import cloudinary from 'wa-storybook/helpers/cloudinary';

type Props = {
  group: InterestGroupT;
  onSelect: (id: string, isSelected?: boolean) => void;
};

const InterestGroup: FC<Props> = ({
  group: { name, icon, interests },
  onSelect,
}: Props) => {
  return (
    <SimpleCard noShadow outline>
      <h3 className={styles.title}>
        <img
          src={cloudinary(icon?.url ?? '', 'w_20', true)}
          alt=''
          className={styles.icon}
        />
        {name}
      </h3>

      <div className={styles.list}>
        {interests.filter(Boolean).map(interest => (
          <CheckboxTag
            key={interest?.id}
            id={interest?.id}
            label={interest?.name ?? ''}
            defaultChecked={interest?.selected}
            onChange={event => {
              onSelect(
                interest?.id ?? '',
                (event.target as HTMLInputElement).checked,
              );
            }}
          />
        ))}
      </div>
    </SimpleCard>
  );
};

export default InterestGroup;
